module.exports = __webpack_public_path__ + "img/logo9.892f4924.png";